<template>
    <div class="root" v-loading="loading">
        <router-link to="/result" replace>
            <div class="header">
                <div class="iconfont back-icon">&#xe624;</div>
                <div class="headertxt">
                    错题集
                </div>
            </div>
        </router-link>

        <div style="display:flex; color:#fff; width: 90vw; margin:10px auto 5px auto;">
            <div style="flex:1;">
                倒计时：{{fen}}:{{miao}}
            </div>
        </div>

        <div class="questiondiv">



            <div v-for="(item, index) in list" :key="item.id">
                <div>
                    <div class="questiontitle">
                        {{ index + 1 }}、{{ item.title }}
                    </div>
                    <div class="questionoptions">
                        <div :class="item.rightcode==op.code?'selected2 option':item.answer==op.code?'selected option':'option'"
                            v-for="(op,oindex) in item.options" :key="op.id" @click="optionclick(index,oindex)">
                            {{ op.code }}、{{ op.txt }}
                        </div>
                    </div>
                    <div style="display:flex; margin:10px 0; padding-bottom: 10px; border-bottom: 1px #999 dashed;">
                        <div style="flex:1; color:green;">正确答案：{{item.rightcode}}</div>
                        <div style="color:#BA0109;">错误答案：{{item.answer}}</div>
                    </div>
                </div>
            </div>

        </div>


    </div>
</template>

<script>

import axios from 'axios'

export default {
    name: 'wenda',
    data: function () {
        return {
            radio: '1',
            list: [],
            dialogVisible: false,
            time:180,
            fen:'00',
            miao:'00',
        loading:false
        }
    },
    components: {

    },
    methods: {
        
        getHomeInfo() {
            this.loading=true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Question/cuotiji',
                {
                    limit: 50,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.getHomeInfoSucc)
        },
        getHomeInfoSucc(res) {
            this.loading=false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.list = res.list
                console.log(this.list);
            }else{
                if(res && res.Code == 301){
                    localStorage.removeItem('userJson');
                    this.$router.replace('/');
                }
            }
        },

        // 开始计时
        startHandler() {
            this.flag = setInterval(() => {
               
                this.time--;
                var fen = parseInt(this.time/60);
                var miao = parseInt(this.time%60);
                if(miao<10){
                    miao = "0"+miao;
                }
                if(fen<10){
                    fen = "0"+fen;
                }
                this.fen = fen;
                this.miao = miao;
                if(this.time<=0){
                    this.endHandler();
                    this.$router.replace("/");
                }
            }, 1000)
        },
        // 暂停计时
        endHandler() {
            this.flag = clearInterval(this.flag)
        }
    },
    mounted() {
        this.getHomeInfo()
        this.startHandler()
    },
    beforeDestroy() {
        if (this.flag) { //如果定时器还在运行 或者直接关闭，不用判断
            clearInterval(this.flag); //关闭
        }
    }
}
</script>
<style scoped>
.root { 
    background-repeat: no-repeat;
    background-size: 100%;
    width: 100%;
    height: 100vh;
    overflow-y: scroll;
}

.header {
    padding: .24rem;
    display: flex;
}
.headertxt{
    flex: 1;
    text-align: center;
    color:#fff;
    margin-right: 20px;
    line-height: 20px;
}
.back-icon {
    font-size: .4rem;
    color: #fff;
}

.questiondiv {
    height: calc(100vh - 93px);
    overflow-y: scroll;
    background: #fff;
    width: 90vw;
    margin: 0px auto 20px auto;
    padding: 12px;
    border-radius: 5px;
    box-sizing: border-box;
}

.questiontitle {
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 10px;
}

.option {
    font-size: 18px;
    margin-bottom: 10px;
    border: 1px #f1f1f1 solid;
    padding: 10px;
    line-height: 22px;
}

.option.selected {
    border-color: #BA0109;
    color: #BA0109;
    text-decoration: line-through;
}
.option.selected2{
    
    border-color: green;
    color: green;

}

.mybtns{
    width: 80vw;
    display: flex;
    margin: 20px auto;
}
.btnpre{
flex: 1;
margin-right: 10px;
color:#e6a23c;
text-align: center;
padding:10px;
border-radius: 1000px;
border:1px solid #e6a23c;
}
.btnnext{
flex: 1;
margin-left: 10px;
color:#fff;
text-align: center;
padding:10px;
border-radius: 1000px;
background: #e6a23c;
}
.btnsubmit{
flex: 1;
margin-left: 10px;
color:#fff;
text-align: center;
padding:10px;
border-radius: 1000px;
background: #67c23a;
}
.errmsg{
    color:red;
    width: 90vw;
    margin:10px auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/cuotiji/cuotiji.vue